<nav class="sidebar" [class.collapsed]="isCollapsed" *ngIf="loggedIn">
  <div class="sidebar-header">
    <h2 class="sidebar-title" *ngIf="!isCollapsed">Milestone</h2>
  </div>

  <div class="sidebar-content" [class.is-collapsed]="isCollapsed">

    <div class="sidebar-section">
      <div class="sidebar-section-header">
        <span class="section-title">PROJECT MANAGEMENT</span>
      </div>
      <ul class="sidebar-menu">
        <li class="sidebar-menu-item">
          <a routerLink="/projects" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}"
            class="sidebar-link" [attr.title]="isCollapsed ? 'Projects' : null">
            <fa-icon [icon]="faThLarge" class="menu-icon"></fa-icon>
            <span class="menu-text">Projects</span>
          </a>
        </li>
        <li class="sidebar-menu-item">
          <a routerLink="/user-sessions" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}"
            class="sidebar-link" [attr.title]="isCollapsed ? 'User Session' : null">
            <fa-icon [icon]="faUser" class="menu-icon"></fa-icon>
            <span class="menu-text">User Session</span>
          </a>
        </li>
      </ul>
    </div>

    <div class="sidebar-section">
      <div class="sidebar-section-header">
        <span class="section-title">SYSTEM</span>
      </div>
      <ul class="sidebar-menu">
        <li class="sidebar-menu-item">
          <a routerLink="/feature-releases" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}"
            class="sidebar-link" [attr.title]="isCollapsed ? 'Features' : null">
            <fa-icon [icon]="faNewspaper" class="menu-icon"></fa-icon>
            <span class="menu-text">Features
              <div *ngIf="hasNewSystemUpdates" class="new-icon" title="New updates available">New</div>
            </span>
          </a>
        </li>
        <li class="sidebar-menu-item">
          <a routerLink="/readiness-guide" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}"
            class="sidebar-link" [attr.title]="isCollapsed ? 'Readiness' : null">
            <fa-icon [icon]="iconExecutionLink" class="menu-icon"></fa-icon>
            <span class="menu-text">Readiness</span>
          </a>
        </li>
        <li class="sidebar-menu-item">
          <a routerLink="/support-tickets" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}"
            class="sidebar-link" [attr.title]="isCollapsed ? 'Support' : null">
            <fa-icon [icon]="faLifeRing" class="menu-icon"></fa-icon>
            <span class="menu-text">Support</span>
          </a>
        </li>
      </ul>
    </div>

    <div class="recent-projects-container" *ngIf="loggedIn && !isCollapsed">
      <div class="recent-projects-header">
        <h5 class="recent-projects-title">Latest Accessed Projects</h5>
      </div>

      <div class="recent-projects-list" *ngIf="recentProjects.length > 0; else noProjects">
        <button type="button" class="recent-project-card" *ngFor="let project of recentProjects"
          [routerLink]="['/project', project.ProjectId]" [title]="project.Name">
          <div class="recent-project-card__top">
            <div class="recent-project-card__name">{{ project.Name }}</div>
            <span class="recent-project-card__time">{{ getTimeAgo(project.lastAccessed) }}</span>
          </div>

          <div class="recent-project-card__meta">
            <span class="recent-project-card__client-asset">
              {{ project.Client?.Name }} — {{ project.Asset?.Name }}
            </span>
            <span class="recent-project-card__icons">
              <fa-icon *ngIf="project.ReadinessAssessmentPath != null || project.DisplayReadiness"
                [icon]="faWorkPackIcon" title="Readiness Assessment" class="recent-icon"></fa-icon>
              <fa-icon *ngIf="project.SiteSenseIdentifiers?.length > 0" [icon]="faMaterialLink"
                title="Materials Tracking" class="recent-icon"></fa-icon>
              <fa-icon *ngIf="project.PrimaveraIdentifiers?.length > 0" [icon]="iconExecutionLink"
                title="Project Execution" class="recent-icon"></fa-icon>
              <fa-icon *ngIf="project.CXPlannerIdentifiers?.length > 0" [icon]="faCXPlannerLink" title="Open CX Planner"
                class="recent-icon"></fa-icon>
              <fa-icon *ngIf="project.IsFavorite" [icon]="faStar" class="recent-icon favorite"
                title="Favorite"></fa-icon>
            </span>
          </div>
        </button>
      </div>

      <ng-template #noProjects>
        <div class="recent-projects-empty">
          <p>No recently accessed projects.</p>
        </div>
      </ng-template>
    </div>
  </div>
</nav>